const Skeleton = () => {
  return (
    <div className="animate-pulse" role="status">
      <div className="bg-white-100 border-b-darkKnight-200 z-[999999] w-full border-b-[1px] py-2 md:py-3">
        <div className="flex max-w-[1188px] items-center justify-between px-4 md:container md:px-0 lg:gap-10">
          <div className="flex flex-row gap-4">
            <div className="h-10 w-28 bg-gray-200"></div>
            <div className="flex items-center justify-start gap-6">
              <div className="h-3 w-10 rounded-xl bg-gray-200"></div>
              <div className="h-3 w-14 rounded-xl bg-gray-200"></div>
            </div>
          </div>
          <div>
            <div className="flex h-10 w-[576px] items-center justify-end rounded-full bg-gray-200 p-1">
              <div className="size-8 rounded-full bg-gray-400"></div>
            </div>
          </div>
          <div className="flex items-center justify-end gap-4">
            <div className="size-8 rounded-full bg-gray-200"></div>
            <div className="size-8 rounded-full bg-gray-200"></div>
            <div className="size-8 rounded-full bg-gray-200"></div>
            <div className="flex w-[138.96px] items-center justify-start rounded-full bg-gray-100 p-1">
              <div className="size-8 rounded-full bg-gray-300"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
